import Loadable from 'react-loadable';
import ComponentLoading from 'components/ComponentLoading/ComponentLoading';
var LoadableClientDetailWrap = Loadable({
  loader: function loader() {
    return import('../Clients/ClientDetailWrap.jsx');
  },
  loading: ComponentLoading
});
export default LoadableClientDetailWrap;